import { AppRouteGroup } from 'utils/routing/AppRouteGroup';

export const orgDashboardRouteGroup = new AppRouteGroup({
  path: '/admin/:orgId',
  params: ['orgId'],
});

export const orgDashboardHomeRoute = orgDashboardRouteGroup.route({ path: '' });

export const orgDashboardPostAListingRoute = orgDashboardRouteGroup.route({
  path: 'post-a-listing',
});

// Org

export const orgDashboardPreviewOrgRoute = orgDashboardRouteGroup.route({
  path: 'preview',
});

export const orgDashboardEditOrgRoute = orgDashboardRouteGroup.route({
  path: 'edit',
});

// Admins

export const orgDashboardManageAdminsRoute = orgDashboardRouteGroup.route({
  path: 'admins',
});

// Checkout

export const orgDashboardCartRoute = orgDashboardRouteGroup.route({
  path: 'cart',
});

export const orgDashboardCheckoutCartRoute = orgDashboardRouteGroup.route({
  path: 'single-checkout/cart',
});

export const orgDashboardCheckoutBillingAddressRoute =
  orgDashboardRouteGroup.route({
    path: 'checkout/billing-address',
    searchParams: ['pack', 'invoiceId'],
  });

export const orgDashboardPayByCreditCartRoute = orgDashboardRouteGroup.route({
  path: 'pay-by-credit-card',
});

// Credits

export const orgDashboardCreditsRoute = orgDashboardRouteGroup.route({
  path: 'credits',
});

export const orgDashboardBuyCreditPacksRoute = orgDashboardRouteGroup.route({
  path: 'buy-credits',
});

export const orgDashboardViewCreditPackRoute = orgDashboardRouteGroup.route({
  path: 'credits/:packId',
});

// Api

export const orgDashboardApiAccessRoute = orgDashboardRouteGroup.route({
  path: 'api-access',
});

// Integrations

export const orgDashboardIntegrationsRoute = orgDashboardRouteGroup.route({
  path: 'integrations',
});

export const orgDashboardGreenhouseIntegrationRoute =
  orgDashboardRouteGroup.route({
    path: 'integrations/greenhouse',
  });

export const orgDashboardJazzHrIntegrationRoute = orgDashboardRouteGroup.route({
  path: 'integrations/jazzhr',
});

// Grad Program

// Invoice

export const orgDashboardListInvoicesRoute = orgDashboardRouteGroup.route({
  path: 'invoices',
});

export const orgDashboardViewInvoiceRoute = orgDashboardRouteGroup.route({
  path: 'invoices/:invoiceId',
  params: ['invoiceId'],
});

export const orgDashboardInvoiceBillingAddressRoute =
  orgDashboardRouteGroup.route({
    path: 'invoices/:invoiceId/billing-address',
    params: ['invoiceId'],
  });

// Payments

export const orgDashboardListPaymentsRoute = orgDashboardRouteGroup.route({
  path: 'payments',
});

export const orgDashboardViewPaymentRoute = orgDashboardRouteGroup.route({
  path: 'payments/:paymentId',
  params: ['paymentId'],
});

export const orgDashboardPaymentSummaryRoute = orgDashboardRouteGroup.route({
  path: 'payment-summary',
});

// Listings

export const orgDashboardManageListingsRoute = orgDashboardRouteGroup.route({
  path: '',
});

// Job

export const orgDashboardViewJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/:jobId',
  params: ['jobId'],
});

export const orgDashboardPreviewJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/:jobId/preview',
  params: ['jobId'],
});

export const orgDashboardCreateJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/create',
});

export const orgDashboardEditJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/:jobId/edit',
  params: ['jobId'],
});

export const orgDashboardRepostJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/:jobId/repost',
  params: ['jobId'],
});

export const orgDashboardListJobRecommendedCandidatesRoute =
  orgDashboardRouteGroup.route({
    path: 'jobs/:jobId/recommended-candidates',
    params: ['jobId'],
  });

export const orgDashboardViewJobRecommendedCandidatesRoute =
  orgDashboardRouteGroup.route({
    path: 'jobs/:jobId/recommended-candidates/:applicantId',
    params: ['jobId', 'applicantId'],
  });

// Internship

export const orgDashboardViewInternshipRoute = orgDashboardRouteGroup.route({
  path: 'internships/:internshipId',
  params: ['internshipId'],
});

export const orgDashboardPreviewInternshipRoute = orgDashboardRouteGroup.route({
  path: 'internships/:internshipId/preview',
  params: ['internshipId'],
});

export const orgDashboardEditInternshipRoute = orgDashboardRouteGroup.route({
  path: 'internships/:internshipId/edit',
  params: ['internshipId'],
});

export const orgDashboardCreateInternshipRoute = orgDashboardRouteGroup.route({
  path: 'internships/create',
});

export const orgDashboardRepostInternshipRoute = orgDashboardRouteGroup.route({
  path: 'internships/:internshipId/repost',
  params: ['internshipId'],
});

// Volop

export const orgDashboardViewVolopRoute = orgDashboardRouteGroup.route({
  path: 'volops/:volopId',
  params: ['volopId'],
});

export const orgDashboardPreviewVolopRoute = orgDashboardRouteGroup.route({
  path: 'volops/:volopId/preview',
  params: ['volopId'],
});

export const orgDashboardCreateVolopRoute = orgDashboardRouteGroup.route({
  path: 'volops/create',
});

export const orgDashboardEditVolopRoute = orgDashboardRouteGroup.route({
  path: 'volops/:volopId/edit',
  params: ['volopId'],
});

export const orgDashboardRepostVolopRoute = orgDashboardRouteGroup.route({
  path: 'volops/:volopId/repost',
  params: ['volopId'],
});

// Grad Programs

export const orgDashboardViewGradProgramRoute = orgDashboardRouteGroup.route({
  path: 'grad-program',
});

export const orgDashboardAddGradProgramRoute = orgDashboardRouteGroup.route({
  path: 'grad-program/add',
});

export const orgDashboardEditGradProgramRoute = orgDashboardRouteGroup.route({
  path: 'grad-program/edit',
});

export const orgDashboardPreviewGradProgramRoute = orgDashboardRouteGroup.route(
  {
    path: 'grad-program/preview',
  },
);

export const orgDashboardGradProgramContactsRoute =
  orgDashboardRouteGroup.route({
    path: 'grad-program-contacts',
  });

// Grad Fairs

export const orgDashboardGradFairsHomeRoute = orgDashboardRouteGroup.route({
  path: 'grad-fairs',
});

export const orgDashboardViewGradFairInviteRoute = orgDashboardRouteGroup.route(
  {
    path: 'grad-fairs/invites/:inviteId',
    params: [':inviteId'],
  },
);

// Applications

export const orgDashboardViewApplicationRoute = orgDashboardRouteGroup.route({
  path: 'applications/:applicationId',
  params: ['applicationId'],
});

// Preferences

export const orgDashboardNotificationPreferencesRoute =
  orgDashboardRouteGroup.route({
    path: 'notification-preferences',
  });
